import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Story } from '../../../../services';
import { isStoryFollowable, useIsFollowAllowed } from '../../../../shared';

import classNames from 'classnames';
import classes from './StoryFollowStatus.module.scss';

interface StoryFollowStatusProps {
  story: Story;
}

export const StoryFollowStatus: FunctionComponent<StoryFollowStatusProps> = memo(({ story }) => {
  const { t } = useTranslation();

  const isFollowAllowed = useIsFollowAllowed();

  const { feedFollowedStatus } = story;

  if (!isFollowAllowed || !isStoryFollowable(story)) {
    return null;
  }

  return (
    <div
      className={classNames(classes['story-follow-status'], {
        [classes['story-follow-status--followed']]: feedFollowedStatus,
      })}
    >
      <span className={classes['story-follow-status__dot']} />
      {t(`myTopics.${feedFollowedStatus ? 'followed' : 'unfollowed'}`)}
    </div>
  );
});
